import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicControlsComponent } from './dynamic-controls.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { SingleSelectWithSearchComponent } from './single-select-with-search/single-select-with-search.component';
import { YearPickerComponent } from './year-picker/year-picker.component';
import { MatIconModule } from '@angular/material/icon';
import { MasterDataService } from './master-data-service';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatInputModule,
        MatDatepickerModule,
        MatButtonModule,
        MatExpansionModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatDividerModule,
        MatIconModule,
        DynamicControlsComponent,
        SingleSelectWithSearchComponent,
        YearPickerComponent
    ],
    providers: [
        MasterDataService,
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }
    ],
    exports: [DynamicControlsComponent]
})
export class DynamicControlsModule { }
